import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { WidgetStatePlaceholderEnum } from '@shared/enums/widget-state-placeholder.enum';
import { CustomEventService } from '@shared/services/custom-event.service';
import { GlobalSettingsService } from '@shared/services/global-settings.service';
import { WidgetService } from '@shared/services/widget.service';
import colorMap from '@shared/variables/chart-color.variable';
import { EChartOption } from 'echarts';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-azure-devops-release-widget',
  templateUrl: './azure-devops-release-widget.component.html'
})
export class AzureDevopsReleaseWidgetComponent implements OnInit {

  @Input() dateFilterable: boolean;
  widgetId: string;
  widgetName: string;
  widgetType: string;
  widgetFooter: Widget.FooterModel;
  headerAddon: string;
  headerComponents: [] = [];
  selectedDate: string;
  note: string;
  url: string;
  from: number;
  showDownloadIcon: boolean;

  loading: boolean;
  initialLoading: boolean;
  widgetStatePlaceholderEnum = WidgetStatePlaceholderEnum;
  showWidgetStatePlaceholder: WidgetStatePlaceholderEnum;

  dateFormat: string;

  chartOption: EChartOption;

  chartData: ReleaseWidget.ReleaseWidgetModel;
  tooltipIndex: number;
  tooltip: string;

  @Input()
  set period(period: string) {
    if (period === 'FROM') {
      this.selectedDate = this.from.toString(10);
    } else if (period === 'TODAY') {
      this.selectedDate = `${period}`;
    } else if (period) {
      this.selectedDate = `FROM_LAST_${period}`;
    }
  };

  @ViewChild('toolTipTitle') toolTipTitle: TemplateRef<any>;
  toolTipHTML: string;

  constructor(private widgetService: WidgetService,
              private customEventService: CustomEventService,
              private globalSettingsService: GlobalSettingsService) { }

  ngOnInit(): void {
    this.dateFormat = this.globalSettingsService.dateFormat;

    this.toolTipHTML = this.headerComponents.join('<br>');

    this.loadWidgetData(true);

    // Subscribe to the dashboard announcements to update
    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(({ action, data }) => {
      if (action === ActionTypesEnum.UPDATE_WIDGET_DATA) {
        this.loadWidgetData();
      }

      if (action === ActionTypesEnum.UPDATE_WIDGET_DATE) {
        const { id, date } = data;

        if (this.widgetId === id) {
          this.selectedDate = date;
          this.loadWidgetData();
        }
      }

    });
  }

  loadWidgetData(initial?: boolean): void {
    this.loading = true;

    if (initial) {
      this.loading = true;
    }

    this.widgetService.get(this.widgetId, this.selectedDate)
      .pipe(untilDestroyed(this), take(1))
      .subscribe(response => {
        this.loading = false;
        this.initialLoading = false;

        if (response.data.series.length === 0) {
          this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_AVAILABLE;
          return;
        }

        this.showWidgetStatePlaceholder = undefined;
        this.chartData = response;

        this.chartOption = {
          tooltip : {
            trigger: 'axis',
            formatter: (params: any) => {
              if (this.tooltipIndex !== params[0].dataIndex) {
                this.tooltipIndex = params[0].dataIndex;
                const tooltipData = this.chartData.data.tooltips[params[0].dataIndex].map((item) => item.key + ':' + item.value).join('<br>');
                this.tooltip = tooltipData;
              }
              return `${this.tooltip}`
            },
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: this.chartData.data.xAxis
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              type: 'bar',
              data:  this.chartData.data.series,
              itemStyle: {
                normal: {
                  color: colorMap.get('status')[3]
                }
              }
            }
          ]
        };
      }, error => {
        this.loading = false;
        this.initialLoading = false;
        this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_AVAILABLE;
      });
  }

}
